<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-liucshezhi`]" width="1em" height="1em" v-bind="$attrs"><path d="M39.2856595,110 L70.7143405,110 L70.7143405,78.571319 L39.2856595,78.571319 L39.2856595,110 Z M47.1426379,102.143022 L62.8573621,102.143022 L62.8573621,86.4282974 L47.1426379,86.4282974 L47.1426379,102.143022 Z M94.2852758,78.571319 L94.2852758,54.9996164 L58.9284892,54.9996164 L58.9284892,31.428681 L74.6424461,31.428681 L74.6424461,0 L35.3567866,0 L35.3567866,31.428681 L51.0715108,31.428681 L51.0715108,54.9996164 L15.7139569,54.9996164 L15.7139569,78.571319 L0,78.571319 L0,110 L31.428681,110 L31.428681,78.571319 L23.5717026,78.571319 L23.5717026,62.8573621 L86.4282974,62.8573621 L86.4282974,78.571319 L78.571319,78.571319 L78.571319,110 L110,110 L110,78.571319 L94.2852758,78.571319 Z M7.85697844,102.143022 L23.5717026,102.143022 L23.5717026,86.4282974 L7.85697844,86.4282974 L7.85697844,102.143022 Z M43.2145323,23.5717026 L66.7854677,23.5717026 L66.7854677,7.85697844 L43.2145323,7.85697844 L43.2145323,23.5717026 Z M86.4282974,102.143022 L102.143022,102.143022 L102.143022,86.4282974 L86.4282974,86.4282974 L86.4282974,102.143022 Z" transform="translate(10 10)" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmLiucshezhi',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
